Vendd.Scripts.load(function () {

    // utility functions
    var isNullOrEmptyString = function (val) { return typeof val !== 'string' || !!!val; }
    var cloneObject = function(obj) { return JSON.parse(JSON.stringify(obj)); };

    // popup fix
    if(skodaVariables == null) {
        skodaVariables = window.skodaVariables || (window.top || {}).skodaVariables;
    }

    if(skodaVariables == null)
    {
        return;
    }
    
    // closure
    var carFactory = function(model) {

        var self = this;

        var model = cloneObject(model);

        var applyCarGetters = function(obj) {
            
            Object.defineProperty(obj, "isNew", {
                get() {
                  return this.type === 'new';
                },
            });
    
            Object.defineProperty(obj, "isStock", {
                get() {
                  return this.type === 'stock';
                },
            });
    
            Object.defineProperty(obj, "isUsed", {
                get() {
                  return this.type === 'used';
                },
            });
    
            return obj;
    
        };
    
        var createNewCar = function(obj) {
    
            var result = cloneObject(obj);
    
            result.type = 'new';
            result.category = model.searchLiterals.family;
    
            return applyCarGetters(result);
    
        };
    
        var createStockCar = function(obj) { 
    
            var result = cloneObject(obj);
    
            result.type = 'stock';
            result.category = model.searchLiterals.stockCars;
            result.url = `${model.stockCarsURL}?mbv=${obj.modelCode}`;
    
            return applyCarGetters(result);
    
        };
    
        var createUsedCar = function(obj) { 
    
            var result = cloneObject(obj);
    
            result.type = 'used';
            result.category = model.searchLiterals.usedCars;
            result.url = `${model.usedCarsURL}?mbv=${obj.modelCode}`;
    
            return applyCarGetters(result);
    
        };
    
        self.create = function(obj, type) {
    
            if(!!!obj) {
    
                return null;
    
            }
    
            switch (type) {
                case 'new': return createNewCar(obj);
                case 'stock': return createStockCar(obj);
                case 'used': return createUsedCar(obj);
                default: return null;
            }
    
        }
    
    };

    var createCars = function(model) {

        var factory = new carFactory(model);

        var _createCars = function(array, type) { return (array || []).filter(function(x) { return !!x; }).map(function(x) { return factory.create(x, type); }).filter(function(x) { return !!x; }); };

        return [].concat(
            _createCars(model.cars, 'new')
            , !isNullOrEmptyString(model.stockCarsURL) ? _createCars(model.cars, 'stock') : []
            , !isNullOrEmptyString(model.usedCarsURL) ? _createCars(model.cars, 'used') : []
        );
        
    };

    var sort = function(array, predicate) {
    
        if(typeof predicate !== 'function') {

            return [];

        }

        return (array || []).sort(function(a,b) {
            
            var valOne = predicate(a);
            var valTwo = predicate(b);

            return valOne > valTwo ? 1 : (valOne < valTwo ? -1 : 0);
        });

    };

    skodaVariables.cars = sort(createCars(skodaVariables), function(x) { return x.title });

    var $wrapper = $('.x-searchbox.elastic');

    if ($wrapper.length < 1)
        return;

    var burgerMenu = function () {
        return (window.innerWidth < 1440);
    }

    $.each($wrapper, function (i, wrapper) {
        var $wrapper = $(wrapper);

        var $input = $('.js-keyword', $wrapper);
        $input.val("");

        var $button = $('.js-submit', $wrapper);
        var $toggleButton = $('.js-search-toggle', $wrapper);
        var $closeButton = $('.js-search-close', $wrapper);
        var $container = $('.elastic-container', $wrapper);
        var $suggestions = $('.x-elastic-suggestions', $wrapper);
        var minLength = $wrapper.data('min-search-length');
        var showOnlyProducts = $wrapper.data('only-products');
        var mask = $wrapper.data('mask');
        var noResultsText = $wrapper.data('noresults-text');

        var ajax = $wrapper.data('ajax');
        if (typeof ajax === 'string')
            ajax = ajax.trim().toLowerCase() === 'true';

        var $elastic, model = {};

        var searchTerm = "", suggestionTerm = "", fuzziness = "edit0", source = "all", textTransform = "unmodified",
            since = null, size = 10, count = 0, index = -1;

        if (ajax) {
            $elastic = $(".x-elastic-suggestions", $wrapper);

            if ($elastic.length <= 0)
                throw 'Error: Elastic List does not exist';
            

            Vendd.MessageBus.subscribe(Vendd.ElasticSearch.Messages.GetElasticSuggestionsFailed, wrapper, function (envelope) {
                model.suggestions = null;
                wrapper.loading(false);
            });

            Vendd.MessageBus.subscribe(Vendd.ElasticSearch.Messages.GetElasticSuggestionsSuccess, wrapper, function (envelope) {
                model.suggestions = envelope.message.data.model.response;
                model.Literals = { NoResultsText: noResultsText };

                wrapper.bindSuggestions();

                if (model.suggestions.length < 1)
                    $('.no-results.results', $elastic).addClass('visible');

                setTimeout(function () { wrapper.loading(false); }, 200);

                /* Track Search & SearchTerm */
                if (typeof fbPixelTracker !== 'undefined' && typeof fbPixelCanTrack !== 'undefined') {
                    if (fbPixelTracker && fbPixelTracker.Properties.FacebookPixelId && fbPixelCanTrack) {
                        fbq('track', 'Search');
                        fbq('trackCustom', 'SearchTerm', { search_string: searchTerm });
                    }
                }
                /* END Track Search & SearchTerm */
            });

        }

        wrapper.bindSuggestions = function () {
            var html = Vendd.Handlebars.parse("elasticSuggestions_A", model);
            $suggestions.html(html);

            //init scroll behaviour inside results list
            $container.scrollTop(0);
            index = -1;
            count = 0;
            //bind mark plugin
            performMark();

            //show list
            wrapper.showList(true);
        };

        wrapper.loading = function (loading) {
            if (loading) {
                $wrapper.addClass('x-loading').addClass('x-disabled');
            } else {
                $wrapper.removeClass('x-loading').removeClass('x-disabled');
            }
        };

        wrapper.clearValue = function () {
            $input.val("");
        };

        wrapper.checkSearchTerm = function () {
            var condition = new RegExp('[a-zα-ωάέήίόύώϊϋΐΰςа-я0-9]{' + minLength + ',}', 'i');
            return condition.test(searchTerm);
        };

        wrapper.showList = function (show) {
            if (ajax && $elastic.length > 0) {
                if (show) {
                    $('html').addClass('no-scroll');
                    $elastic.addClass("js-visible");
                    $wrapper.addClass("overlaid");
                    $('.header-region').addClass('active clean-zindex');
                    $(".header-overlay").addClass("active");

                    wrapper.initScrollBehaviour();
                } else {
                    $('html').removeClass('no-scroll');
                    $('.header-region').removeClass('active clean-zindex');
                    $('.header-overlay').removeClass('active');
                    $wrapper.removeClass('overlaid');
                    $elastic.removeClass('js-visible');
                }
            }
        };

        wrapper.expand = function () {
            if ($wrapper.hasClass('expanded')) {
                $wrapper.removeClass('expanded');
                $button.trigger('click');
            } else {
                $wrapper.addClass('expanded');
                $input.focus();
                if ($input.val().length >= minLength && wrapper.checkSearchTerm()) {
                    if (ajax) {
                        wrapper.showList(true);
                    }
                }
            }

        };

        //init scroll behaviour inside results box
        wrapper.initScrollBehaviour = function () {

            if (!$('.suggestion', $suggestions).hasClass('selected'))
                return;

            $('.suggestion', $suggestions).removeClass('selected');

            $container.scrollTop(0);
            index = -1;
            count = 0;
        };

        wrapper.submit = function (term) {
            var searchTerm = term || $input.val();
            var targetUrl = mask.replace("((search))", searchTerm);
            if (showOnlyProducts)
                targetUrl = targetUrl.replace('/search/', '/search-products/');

            document.location = targetUrl;
        };

        wrapper.initSearch = function () {
            if (searchTerm != $input.val()) {
                searchTerm = $input.val();

                if (searchTerm.length >= minLength && wrapper.checkSearchTerm()) {

                    if (burgerMenu()) return; // Disable suggestions on burger menu

                    if (ajax) {
                        wrapper.loading(true);

                        model.suggestions = [];
                        var terms = searchTerm.split(' ');

                        terms.forEach(function (term) {

                            if (term.length < minLength) return;

                            var matchedCars = skodaVariables.cars.filter(function (car) {
                                return car.title.toUpperCase().includes(term.toUpperCase())
                                    && !model.suggestions.some(function (x) { return x.type === car.type && x.id === car.id });
                            });

                            if (matchedCars.length === 0) return;

                            model.suggestions.push.apply(model.suggestions, matchedCars);
                        });

                        model.suggestions.unshift({ "title": searchTerm });

                        wrapper.bindSuggestions();
                        //Vendd.MessageBus.publishAsync(wrapper, new Vendd.ElasticSearch.Messages.GetElasticSuggestions(searchTerm, size, since, textTransform, fuzziness, source));
                    }
                }
            }
        };

        //call service for suggestions using user's input
        $input.keyup($.debounce(500, function (e) {
            wrapper.initSearch();          
        }));

        //call service for suggestions using user's paste
        $input.bind('paste', function (e) {
            if (!e.keyCode) {
                setTimeout(function () {
                    wrapper.initSearch();
                }, 10);
            }
        });

        //keyboard enter button
        $input.keyup(function (e) {
            if (e.keyCode === 13 && $input.val().length >= minLength && wrapper.checkSearchTerm()) {

                if (burgerMenu()) return wrapper.submit(suggestionTerm); // Disable suggestions on burger menu

                //check if there is selected item from suggestions
                var $selectedItem = $('.suggestion.selected', $suggestions);
                var $link = $('a', $selectedItem);

                if ($link.length > 0) {
                    $link.click();
                    window.location = $link.attr('href');
                    return;
                }
                                    
                if ($selectedItem.length > 0)
                    suggestionTerm = $selectedItem.data('suggestion');

                wrapper.submit(suggestionTerm);
            }
            if (searchTerm == $input.val()) {
                $elastic.removeClass('loading');
            } else {
                $elastic.addClass('loading');
            }
        });

        //impementation for down/up key in suggestions
        $input.keydown(function (e) {

            if (e.keyCode != 40 && e.keyCode != 38) return;

            var $listItems = $('.x-elastic-suggestions .suggestion', $wrapper),
                $listHeight = $container.height(),
                $itemHeight, $current;

            var key = e.keyCode;

            $listItems.removeClass('selected');

            // Down key
            if (key == 40) {
                if (index < $listItems.length - 1) {
                    index = index + 1;
                    $current = $listItems.eq(index);
                } else {
                    $current = $listItems.eq(index);
                }

                $itemHeight = $current.offset().top - $container.offset().top;

                if (($itemHeight + 60 >= $listHeight) && (index < $listItems.length - 1)) {
                    count = count + 1;
                    $container.animate({ scrollTop: ($listHeight / 2) * count }, 1);
                }
            }
            // Up key
            else if (key == 38) {
                if (index <= $listItems.length - 1 && index > 0) {
                    index = index - 1;
                    $current = $listItems.eq(index);
                } else {
                    $current = $listItems.eq(index);
                }

                $itemHeight = $current.offset().top - $container.offset().top;

                if ($itemHeight - 60 <= 0 && index > 0) {
                    count = count - 1;
                    $container.animate({ scrollTop: ($listHeight / 2) * count }, 1);
                }
            }

            $current.addClass('selected');

        });

        $input.click(function (e) {
            if (!$wrapper.hasClass('overlaid')) {
                if (searchTerm.length >= minLength && wrapper.checkSearchTerm()) {
                    wrapper.showList(true);
                }
            }
        });

        //$toggleButton.click(function (e) {
        //    if ($wrapper.hasClass('overlaid')) {
        //        wrapper.showList(false);
        //    } else {
        //        wrapper.showList(true);
        //    }
        //});

        $toggleButton.click(function (e) {
            wrapper.expand();
        });

        $closeButton.click(function (e) {
            if ($wrapper.hasClass('overlaid')) {
                wrapper.showList(false);
            } else {
                if ($input.val().length >= minLength && wrapper.checkSearchTerm()) {
                    if (ajax) {
                        wrapper.showList(true);
                    }
                }
            }
        });

        $button.click(function (e) {
            e.preventDefault();
            if ($wrapper.hasClass('overlaid')) {
                wrapper.showList(false);
            } else {
                if ($input.val().length >= minLength && wrapper.checkSearchTerm()) {
                    if (ajax) {
                        wrapper.showList(true);
                    }
                }
                $input.focus();
            }
        });

        $wrapper.on('click', '.suggestion', function (e) {
            if ($(this).attr('data-link')) return;

            e.preventDefault();

            var $this = $(this);

            suggestionTerm = $this.data('suggestion');
            wrapper.submit(suggestionTerm);
        });

        $('.header-overlay').on('click', function () {
            if ($wrapper.hasClass('overlaid')) {
                wrapper.showList(false);
            }
        });

        $(document).keyup(function (e) {
            if (e.keyCode == 27 && $wrapper.hasClass('overlaid')) {
                wrapper.showList(false);
            }
        });

        //init makr.js for highlighting with pure js
        var markInstance = new Mark(document.querySelector('.x-elastic-suggestions'));
        var keywordInput = document.querySelector('.js-keyword');

        function performMark() {

            var keyword = keywordInput.value;

            var options = {
                "diacritics": true,
                "synonyms": { "ά": "α", "έ": "ε", "ή": "η", "ί": "ι", "ό": "ο", "ύ": "υ", "ώ": "ω" }
            };

            markInstance.unmark({
                done: function () {
                    markInstance.mark(keyword, options);
                }
            });
        };

    });

});
